import React from 'react';
import { connect } from "react-redux";
import { pageChange } from '../../action/view';
import AddWorkplanForm from './AddWorkplanForm';
import SelectBranch from './SelectBranch';
import SelectActivity from './SelectActivity';
import SelectUser from './SelectUser';
import * as Constants from '../../Constants';
import Step from './Step';
import AddSuccess from './AddSuccess';

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    pageChange
};

class AddWorkplan extends React.Component {
    constructor(props) {
        super(props);
        this.state =  {
            type: this.props.type,
            done: [],
            editing: 0
        }
    }

    changeStep(id){
        this.setState({
            type: this.state.type,
            done: this.state.done,
            editing: id
        });
    }

    changeStepDone(done){
        this.setState({
            type: this.state.type,
            done: done,
            editing: this.state.editing
        });
    }

    render() {
        
        return (
            <div className="AddWorkplan">
                {this.props.workplanView.add_success ? <AddSuccess></AddSuccess> : 
                <div>
                <Step step_count='3' 
                editing={this.state.editing} 
                changeStep={this.changeStep.bind(this)}
                done={this.state.done}></Step>

                <AddWorkplanForm type={this.state.type} 
                changeStep={this.changeStep.bind(this)}
                changeStepDone={this.changeStepDone.bind(this)}/>

                {this.props.root.overlay ?  
                        this.props.root.view_type === 'branch' ? <SelectBranch></SelectBranch> : 
                        this.props.root.view_type === 'activity' ? <SelectActivity type={Constants.TYPE_DIRECT}></SelectActivity> : 
                        this.props.root.view_type === 'user' ? <SelectUser></SelectUser> : 
                        "" : ""}
                        </div>
                }
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddWorkplan);
